const adobeClickEvent = (
  eventId,
  url = location.origin + location.pathname
) => {
  if (process.env.NODE_ENV === "development") console.log(eventId, url);
  if (!window._sc) return;
  window._sc?.gene_click(eventId, url);
};

export { adobeClickEvent };
